/* Guides and articles: Add to cart on the product cards of an article (sections/abi-guide-article.liquid).
   Each card is a plain form posting to /cart/add, so it works without this file. With it: one POST /cart/add.js,
   then the cart drawer opens with the added line (window.openFlyoutCart, the Cart V2 hook); without the drawer the
   visitor goes to /cart. A failed add shows the store's own reason (422) or the section's message under the button.
   Requests never overlap: every Add button of the page is off while one is running. */
(function () {
  'use strict';
  if (window.__abgGuides) return;
  window.__abgGuides = true;

  var TIMEOUT = 15000;
  var busy = false;

  function root() {
    var r = '/';
    try { if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) r = String(window.Shopify.routes.root); } catch (e) { r = '/'; }
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  function setBusy(shop, btn, on) {
    busy = on;
    var all = shop.querySelectorAll('[data-abg-add]');
    for (var i = 0; i < all.length; i += 1) {
      if (on) all[i].setAttribute('aria-disabled', 'true'); else all[i].removeAttribute('aria-disabled');
    }
    if (!btn) return;
    if (on) {
      // Keep the button's width so the busy label never reflows the card.
      var w = btn.getBoundingClientRect().width;
      if (w > 0) btn.style.minWidth = w + 'px';
      btn.textContent = btn.getAttribute('data-busy-label') || btn.textContent;
    } else {
      btn.style.minWidth = '';
      btn.textContent = btn.getAttribute('data-label') || btn.textContent;
    }
  }
  function showError(form, msg) {
    var slot = form.querySelector('[data-abg-error]');
    if (!slot) return;
    // The slot is always in the page (empty = no height): a live region that appears and gets its text in the same
    // step is often not read out.
    slot.textContent = msg || '';
  }
  function afterAdd(key) {
    if (typeof window.openFlyoutCart === 'function') {
      try {
        var opened = window.openFlyoutCart({ addedKey: key });
        if (opened && typeof opened.then === 'function') opened.then(null, function () { /* the drawer shows its own errors */ });
        return;
      } catch (e) { /* fall through */ }
    }
    var trigger = document.querySelector('.flyout-trigger');
    if (trigger) { trigger.click(); return; }
    window.location.assign(root() + 'cart');
  }
  function add(form, btn) {
    var shop = form.closest('[data-abg-shop]') || document;
    var idField = form.querySelector('input[name="id"]');
    var id = idField ? Number(idField.value) : NaN;
    if (!isFinite(id) || id <= 0 || typeof window.fetch !== 'function') { form.submit(); return; }
    showError(form, '');
    setBusy(shop, btn, true);
    var done = false;
    var ctrl = null;
    try { ctrl = typeof window.AbortController === 'function' ? new window.AbortController() : null; } catch (e) { ctrl = null; }
    var fallback = (shop.getAttribute && shop.getAttribute('data-error')) || '';
    var fail = function (msg) {
      if (done) return;
      done = true;
      clearTimeout(timer);
      setBusy(shop, btn, false);
      showError(form, msg || fallback);
    };
    var timer = setTimeout(function () {
      try { if (ctrl) ctrl.abort(); } catch (e) { /* ignore */ }
      fail('');
    }, TIMEOUT);
    var opts = {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    };
    if (ctrl) opts.signal = ctrl.signal;
    window.fetch(root() + 'cart/add.js', opts).then(function (r) {
      return r.json().then(null, function () { return {}; }).then(function (data) { return { ok: r.ok, status: r.status, data: data || {} }; });
    }).then(function (res) {
      if (done) return;
      if (!res.ok) {
        var reason = String(res.data.description || res.data.message || '').replace(/[.\s]+$/, '');
        fail(res.status === 422 && reason ? reason + '.' : '');
        return;
      }
      done = true;
      clearTimeout(timer);
      setBusy(shop, btn, false);
      var first = (Array.isArray(res.data.items) && res.data.items[0]) || res.data;
      afterAdd(first && first.key ? String(first.key) : null);
    }, function () { fail(''); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-abg-add-form]')) return;
    e.preventDefault();
    var btn = form.querySelector('[data-abg-add]');
    if (busy || (btn && btn.getAttribute('aria-disabled') === 'true')) return;
    add(form, btn);
  });
})();
